<template>
  <div>
    <header-sales></header-sales>
    <div id="subheader"> </div> 
    <div id= "main-container"> 
      <div id= "label-container">
        <span id="label">Estado de Pedidos</span>
      </div> 
      <div id= "container">
        <div id="list-container">
          <item-estado-pedido id="list-prod" v-for="item in items" :item='item' @borradorEliminado="getEstadoPedidos"></item-estado-pedido>
        </div>
      </div> 
    </div> 
  </div>
</template>
 
  
  <script>
    import axios from 'axios'
    import HeaderSales from '@components/views/header.vue';
    import ItemEstadoPedido from '@components/views/estadoPedido/itemEstadoPedido.vue';
 
  
    export default {
      name: 'EstadoPedido',
      
      components:{
        'header-sales': HeaderSales,
        'item-estado-pedido': ItemEstadoPedido,
      },
      
      data() {
         return {
          pedidoRequest:null,
          items: [],
          }
      },  
  
      methods: {
  
        sortPedidos(v) {
          var saved = [], noSaved = [];
          for (var i = 0; i < v.length; i++)
          {
            if (v[i].Estado === 0) 
            {
              saved.push(v[i]);
            } 
            else 
            {
              noSaved.push(v[i]);
            }
          }
          noSaved.sort((a,b)=> {return b.Id - a.Id});
          return saved.concat(noSaved);
        },

        getEstadoPedidos() {
          this.$store.commit('loader/start')
          this.pedidoRequest = {
            'FechaDesde': "01/01/2018",
            'FechaHasta': this.getFechaHasta(),  
            'ClientesId': [this.$store.state.user.cliente.Id],
            'Estado': -1,
            'Pagina': 1,
            'PedidosXPagina': 100
          } 
          axios.post('/WebSalesPedidosListado', this.pedidoRequest ,{
            headers:{
              Token: this.$store.state.user.usuario.Token,
              ClientSecret: process.env.CLIENT_SECRET
            }
          }).then((response) => {
         
            this.$store.commit('loader/stop')
            if (response.data.Code == 0)
            {
              this.items = this.sortPedidos(response.data.Pedidos)  
            }
            else {
                var obj = {
                      txt: response.data.Message,
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
          })
          .catch((error) => {
            this.$store.commit('loader/stop')
            var obj = {
                txt: error.Message,
                txtBtnCancel:'',
                txtBtnOk:'Aceptar',
                fCancel:null,
                fOk:null
            }
            this.$store.commit('popup/open',obj);   
          });
        },
  
  
       getFechaHasta(){
          //'Fecha': "dd/mm/yyyy",  --> 1 dia mas que fecha actual 
          var date   =  new Date();
          date.setMilliseconds(date.getMilliseconds()+86400000) 
          var dia    =  ''
          var mes    =  ''
          if (date.getDate()<10)
          {
            dia = '0'+ date.getDate().toString()
          }
          else
          {
            dia = date.getDate().toString()
          }
          if ((date.getMonth() + 1)<10)
          {
            mes = '0'+ (date.getMonth()+1).toString()
          }
          else
          {
            mes = (date.getMonth()+1).toString()
          }
          return  dia+'/'+mes+'/'+date.getFullYear();
       },
    
      },
  
    
      mounted() {
          this.$store.commit('loader/stop')
          localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
          this.getEstadoPedidos();
      } 

    } 
    
  </script>
  
  
  <style scoped>
  
  
   #subheader {
   width: 100%;
   height: 35vh;
   background: linear-gradient(#005A9F , #1899D6);
   }
  

      #main-container{
        position: absolute;
        top: 55vh;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 700px;
        height: 85vh;
        }

        #label-container{
        width: 700px;
        height: 10vh;
        }

        #label{
        color:#ffffff;
        font-size: 27px;
        }

        #container{
        width: 700px;
        height: 75vh;
        padding-top: 35px;
        border-width: 1px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        box-shadow: 3px 3px 4px #dddddd;
        background-color: #ffffff;
        display: flex;
        flex-direction:column; 
        align-items: center; 
        }

        #list-container{
        width: 660px;
        height: 65vh;
        background: #ffffff;
        overflow: auto;
        display: flex;
        flex-direction:column; 
        align-items: center; 
        }





  /* width */
  ::-webkit-scrollbar {
      width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd; 
      border-radius: 10px;
  }
  
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb; 
      border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc; 
  }
  
  
  ::-webkit-scrollbar { 
  display: block; }
 
  
  /*::-webkit-scrollbar { 
      display: none; 
  }
  */
  
  </style>


// WEBPACK FOOTER //
// src/components/views/estadoPedido/estadoPedido.vue